export enum MeasurementViewType {
    COMPONENT_STATUS = 'componentStatus',
    REPORT_DETAILS = 'reportDetails',
}